import { render, staticRenderFns } from "./freezeReason.vue?vue&type=template&id=87147a62&scoped=true"
import script from "./freezeReason.vue?vue&type=script&lang=js"
export * from "./freezeReason.vue?vue&type=script&lang=js"
import style0 from "./freezeReason.vue?vue&type=style&index=0&id=87147a62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87147a62",
  null
  
)

export default component.exports